module.exports = __webpack_public_path__ + "img/0040030-PS.3d692a40.jpg";